import { trackedCollection } from './tracked';

// Feedback recorded by admins ("admin_feedback").
const feedback = trackedCollection('admin_feedback');

export const subscribeFeedback = feedback.subscribe;
export const createFeedback = feedback.create;
export const updateFeedback = feedback.update;
export const deleteFeedback = feedback.remove;
